export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '平台特色', href: '#features' },
  { label: '热门资源', href: '#media' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export const heroData = {
  tag: '数字系列视频聚合平台',
  siteName: '桃子视频',
  positioning: '全网热门影视剧集一站畅享',
  slogan: '无需注册，打开即看 · 每日更新海量资源',
  description:
    '桃子视频是国内领先的数字系列视频聚合平台，聚焦91视频、97视频、51视频、92视频、98视频等热门站点的优质资源，涵盖高清电影、热播电视剧、综艺动漫、纪录短片等全品类内容。平台无需下载客户端，无需注册登录，点开即可流畅播放，真正实现即点即看。我们支持多线路智能切换和自适应码率播放，在弱网环境下也能保证观看体验不卡顿、不缓冲。',
  stats: [
    { label: '收录资源', value: '50,000+' },
    { label: '日更新量', value: '200+' },
    { label: '线路覆盖', value: '12条' },
  ],
  primaryCta: { label: '立即探索', href: '#media' },
  secondaryCta: { label: '查看榜单', href: '#ranking' },
};

export const faqItems = [
  {
    question: '桃子视频是否需要注册或付费才能观看？',
    answer:
      '完全不需要。桃子视频始终坚持免费开放策略，所有视频资源均可直接在线观看，无需注册账号、无需下载客户端、无需任何付费。您打开网页即可畅享全部内容，我们通过广告合作维持平台运营，绝不向用户收费。',
  },
  {
    question: '91视频、97视频、51视频等资源有什么区别？',
    answer:
      '这些都是不同数字系列视频站点的代号，各自拥有独立的内容库和更新节奏。91视频以国产剧集和综艺见长，97视频侧重日韩影视资源，51视频主打欧美电影和纪录片，92视频和98视频则覆盖动漫、短视频等垂直品类。桃子视频将它们聚合在一起，您无需挨个访问。',
  },
  {
    question: '为什么有些视频加载较慢或无法播放？',
    answer:
      '平台为每部影片配备了多条备用线路，如遇加载缓慢可在播放器底部手动切换。视频资源由各数字站点提供，偶尔会出现源站维护或资源下架的情况，我们的系统会定时检测链接有效性并在24小时内更新替代源。建议优先选择标注"高速线路"的播放通道。',
  },
  {
    question: '手机和电脑上观看体验如何？',
    answer:
      '桃子视频采用响应式自适应设计，在手机、平板和电脑上均可获得良好观看体验。移动端适配了触摸手势控制，支持双击快进、滑动调节音量和亮度。我们没有开发独立的手机 App，直接通过浏览器访问即可，建议添加到手机桌面快捷方式使用。',
  },
];

export const topicsData = [
  { label: '91视频', count: 12860, hot: true },
  { label: '97视频', count: 9850, hot: true },
  { label: '51视频', count: 7620, hot: false },
  { label: '高清电影', count: 15430, hot: true },
  { label: '热播剧集', count: 12340, hot: true },
  { label: '妖精视频', count: 5420, hot: false },
  { label: '92视频', count: 4810, hot: false },
  { label: '98视频', count: 4360, hot: false },
  { label: '小蓝视频', count: 3890, hot: false },
  { label: '综艺动漫', count: 6210, hot: false },
];

export const mediaItems = [
  {
    title: '最新院线大片高清合集',
    category: '电影',
    tag: '91视频',
    views: '128.6万',
    rating: '9.2',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20deep%20crimson%20lighting%2C%20abstract%20film%20reel%20and%20projector%20beam%20composition%2C%20elegant%20dark%20background%20with%20soft%20glow%2C%20editorial%20entertainment%20photography%2C%20rich%20textures%20and%20dramatic%20contrast&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    title: '热播电视剧每日追更专区',
    category: '剧集',
    tag: '97视频',
    views: '95.3万',
    rating: '9.0',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20flat%20screen%20TV%20displaying%20abstract%20colorful%20content%2C%20soft%20ambient%20lighting%20with%20amber%20and%20coral%20tones%2C%20comfortable%20modern%20interior%2C%20entertainment%20lifestyle%20photography%2C%20warm%20atmosphere&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    title: '经典高分日韩剧集精选',
    category: '海外剧',
    tag: '51视频',
    views: '76.1万',
    rating: '8.8',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20warm%20peach%20and%20golden%20light%20streaks%2C%20abstract%20cultural%20Asian%20aesthetic%20elements%2C%20soft%20bokeh%20background%2C%20elegant%20visual%20composition%2C%20film%20noir%20inspired%20warm%20color%20palette%2C%20artistic%20entertainment%20visual&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
];

export const appEntry = {
  title: '移动端畅享指南',
  description:
    '桃子视频无需下载 App，通过手机浏览器访问即可获得完整的观影体验。自适应布局自动匹配屏幕尺寸，触控手势流畅操控。支持将本站添加到手机桌面，一键直达不迷路。',
  steps: [
    { icon: 'ri-safari-line', label: '浏览器打开' },
    { icon: 'ri-smartphone-line', label: '自适应适配' },
    { icon: 'ri-add-box-line', label: '添加到桌面' },
    { icon: 'ri-play-circle-line', label: '即点即看' },
  ],
};

export const contactEntry = {
  title: '资源投稿与合作',
  description:
    '如果您有优质视频资源希望收录到桃子视频，或者有商业合作意向，欢迎通过以下方式联系我们。我们期待与优质内容提供方建立长期合作关系，共同为广大用户提供更丰富的观影选择。',
  email: 'contact@taozivideo.com',
  features: ['资源收录申请', '广告商务合作', '版权问题反馈', '线路优化建议'],
};

export const indexItems = [
  { title: '本周热播剧集 TOP 20', count: '20部', tag: '热门', icon: 'ri-fire-line' },
  { title: '院线大片抢先看合集', count: '35部', tag: '新上', icon: 'ri-movie-line' },
  { title: '91视频精选资源专区', count: '200+', tag: '91站', icon: 'ri-star-line' },
  { title: '日韩高分剧集汇总', count: '88部', tag: '高分', icon: 'ri-tv-line' },
  { title: '纪录片深度探索频道', count: '120部', tag: '知识', icon: 'ri-lightbulb-line' },
  { title: '综艺爆笑名场面集锦', count: '60期', tag: '搞笑', icon: 'ri-emotion-laugh-line' },
  { title: '动漫热血追番日历', count: '45部', tag: '连载', icon: 'ri-rocket-line' },
];

export const updatesData = [
  {
    date: '2026-07-30',
    title: '平台新增两条高速播放线路，晚间高峰观影更流畅',
    tag: '线路升级',
  },
  {
    date: '2026-07-28',
    title: '91视频专区本月新增 320 部高清电影资源上架',
    tag: '资源更新',
  },
  {
    date: '2026-07-25',
    title: '移动端播放器优化完成，手势操作响应速度提升 40%',
    tag: '体验优化',
  },
  {
    date: '2026-07-22',
    title: '51视频欧美电影频道完成全面改版，分类更清晰',
    tag: '频道改版',
  },
  {
    date: '2026-07-18',
    title: '热门剧集《追风者》全集更新完毕，支持一键连播',
    tag: '剧集完结',
  },
  {
    date: '2026-07-15',
    title: '98视频动漫专区新增 28 部热门番剧，含中文字幕',
    tag: '动漫上新',
  },
  {
    date: '2026-07-10',
    title: '平台服务器扩容完成，支持同时在线人数翻倍',
    tag: '扩容',
  },
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    description: '智能 CDN 调度与多线路备份机制，确保视频秒开不等待，即使在网络不佳时也能自动切换最优线路。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: 'PC、平板、手机全终端自适应布局，无需安装任何 App，浏览器打开即可获得最佳观看体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无忧',
    description: '全站 HTTPS 加密传输，无弹窗广告、无恶意跳转、无捆绑下载，给您干净纯粹的观影环境。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    description: '编辑团队全天候监测各大数字站点动态，热门影视资源上线后最快 30 分钟内同步收录。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '精准聚合',
    description: '聚合 91、97、51、92、98 等十余个数字系列站点的优质资源，一个平台畅享全网热门内容。',
  },
];

export const rankingData = [
  { rank: 1, title: '《追风者》谍战大剧', category: '电视剧', heat: '🔥 286万', tag: '91视频' },
  { rank: 2, title: '《星际穿越》4K重制', category: '电影', heat: '🔥 254万', tag: '97视频' },
  { rank: 3, title: '《Running Man》最新季', category: '综艺', heat: '🔥 198万', tag: '51视频' },
  { rank: 4, title: '《鬼灭之刃》锻刀村篇', category: '动漫', heat: '🔥 175万', tag: '98视频' },
  { rank: 5, title: '《隐秘的角落》完整版', category: '国产剧', heat: '🔥 152万', tag: '92视频' },
  { rank: 6, title: '《蓝色星球3》4K纪录', category: '纪录片', heat: '🔥 128万', tag: '51视频' },
];

export const commentsData = [
  {
    name: '老司机阿强',
    time: '2小时前',
    avatar: 'R',
    text: '这个站真的良心，不用注册直接看，资源更新速度也快。91视频那边的剧基本当天就更了，比别的站强太多了。',
    likes: 128,
  },
  {
    name: '追剧小能手',
    time: '5小时前',
    avatar: 'M',
    text: '找了好久97视频的资源入口都没找到能用的，终于在桃子视频这里能稳定看了，画质清晰，多条线路随便切。',
    likes: 96,
  },
  {
    name: '夜色旅人',
    time: '8小时前',
    avatar: 'Y',
    text: '手机端体验意外的好，添加到桌面后跟原生App差不多。51视频的欧美纪录片专区太赞了，每部都有中文字幕。',
    likes: 73,
  },
  {
    name: '电影发烧友K',
    time: '12小时前',
    avatar: 'K',
    text: '小蓝视频和妖精视频的资源以前要去好几个站找，现在一个页面全搞定了。希望继续保持这样的更新频率，已推荐给朋友。',
    likes: 55,
  },
  {
    name: '快乐肥宅水',
    time: '1天前',
    avatar: 'H',
    text: '98视频的动漫资源和92视频的剧集都很全，线路稳定没怎么卡过。唯一建议是加个夜间模式就好了，晚上看屏幕不太舒服。',
    likes: 42,
  },
];

export const cardsData = [
  {
    title: '国产剧集热播专区',
    description: '91视频、92视频最新国产剧集一网打尽，含热播大剧、经典老剧、网剧精选。每日同步更新，追剧不等待。',
    icon: 'ri-tv-2-line',
    color: 'primary',
  },
  {
    title: '日韩影视资源总汇',
    description: '97视频独家日韩剧集与电影资源，热门韩剧日剧实时追踪，高清中字版本优先上架，韩影日影经典收藏。',
    icon: 'ri-earth-line',
    color: 'accent',
  },
  {
    title: '欧美大片高清频道',
    description: '51视频好莱坞院线大片、经典老片、独立电影全覆盖，4K超清画质可选，英语原声与国语配音双版本。',
    icon: 'ri-film-line',
    color: 'secondary',
  },
  {
    title: '动漫二次元基地',
    description: '98视频动漫专区每月上新 20+ 番剧，从热血战斗到治愈日常全品类覆盖，含同步更新的连载番和已完结经典。',
    icon: 'ri-ghost-line',
    color: 'primary',
  },
  {
    title: '妖精小蓝短视频精选',
    description: '小蓝视频与妖精视频的短视频精选，趣味内容、生活百科、创意短片每日推荐，碎片时间轻松刷不停。',
    icon: 'ri-vidicon-line',
    color: 'accent',
  },
];

export const aboutData = {
  title: '关于桃子视频',
  description:
    '桃子视频是一个致力于聚合数字系列视频站点优质资源的在线观影平台。我们整合了91视频、97视频、51视频、92视频、98视频等十余个渠道的内容，覆盖高清电影、热播电视剧、综艺动漫、纪录短片、小蓝视频和妖精视频等全品类资源。平台始终坚持免费开放、无需注册的策略，通过智能线路调度为全国用户提供流畅稳定的观影服务。自上线以来，桃子视频已累计收录超过五万部影视资源，日均服务独立访客超过十万人次。我们将持续优化技术架构和内容覆盖，努力成为您首选的在线观影入口。',
  stats: [
    { label: '收录资源', value: '50,000+' },
    { label: '合作站点', value: '12家' },
    { label: '日活用户', value: '10万+' },
  ],
};

export const carouselItems = [
  {
    title: '暑期档热映大片一站式聚合',
    subtitle: '院线同步·高清画质',
    description: '今夏最受期待的院线大片均已收录，91视频、97视频多线路可切换，无需去影院即可享受大屏观影体验。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20atmosphere%20with%20warm%20golden%20sunset%20cinema%20aesthetic%2C%20abstract%20movie%20elements%20floating%20in%20dramatic%20light%2C%20peach%20and%20coral%20color%20palette%2C%20film%20strip%20texture%2C%20epic%20entertainment%20visual%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '日韩热播剧集追更日历',
    subtitle: '97视频·独家资源',
    description: '97视频站最新日韩剧集同步更新，每周追更日历一目了然，热门韩剧日剧第一时间上架高清中文字幕版。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20drama%20cinematic%20scene%20with%20warm%20lighting%20and%20soft%20cherry%20blossom%20petals%2C%20modern%20romantic%20atmosphere%2C%20peach%20and%20golden%20tone%20gradients%2C%20high%20end%20K-drama%20style%20visual%2C%20artistic%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '动漫番剧七月新番速递',
    subtitle: '98视频·追番必备',
    description: '98视频动漫专区七月新番全面上线，热血、恋爱、搞笑、异世界全类型覆盖，中日双语字幕随心切换。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20visual%20with%20dynamic%20color%20explosion%2C%20warm%20peach%20and%20coral%20gradient%20background%2C%20abstract%20energy%20waves%20and%20sparkles%2C%20entertainment%20and%20action%20atmosphere%2C%20high%20contrast%20with%20golden%20accents&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '经典高分纪录片深度探索',
    subtitle: '51视频·知识频道',
    description: '51视频欧美纪录片频道全面升级，BBC、国家地理、Discovery经典系列全收录，蓝光画质中英双语字幕。',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20style%20cinematic%20nature%20and%20science%20visual%2C%20warm%20amber%20and%20golden%20light%20rays%20through%20abstract%20lens%2C%20knowledge%20and%20exploration%20aesthetic%2C%20elegant%20dark%20background%20with%20soft%20illuminated%20elements%2C%20sophisticated%20visual%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];